export const screenHeightMixin = {
  mounted() {
    this.__screenHeightMixinUpdateVHUnitSize();

    window.addEventListener('resize', this.__screenHeightMixinUpdateVHUnitSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__screenHeightMixinUpdateVHUnitSize);
  },
  methods: {
    __screenHeightMixinUpdateVHUnitSize() {
      const windowInnerHeight = window.innerHeight;

      document.body.style.setProperty('--screen-height', `${windowInnerHeight}px`);
    }
  }
};
